import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TitleBar from '../TitleBar/TitleBar';
import SideBar from '../SideBar/SideBar';
import classes from './Layout.css';

class Layout extends Component {
  state = {
    sideMenuTriggered: false
  };

  handleSideBarTrigger = () => {
    this.setState({
      sideMenuTriggered: true
    });
  };

  handleSideBarClose = () => {
    this.setState({
      sideMenuTriggered: false
    });
  };

  render() {
    const {
      title,
      clicked,
      children,
      country,
      language,
      selectedCanadaEN,
      selectedCanadaFR,
      selectedUSA,
      wideHeading
    } = this.props;

    return (
      <div
        className={
          this.state.sideMenuTriggered
            ? classes.DisableBgdScroll
            : classes.PageWrapper
        }
      >
        <TitleBar
          title={title}
          clicked={clicked}
          country={country}
          language={language}
          sideMenuTriggered={this.state.sideMenuTriggered}
          sideMenuHandler={this.handleSideBarTrigger}
          wideHeading={wideHeading}
        />
        <div className={classes.ContentWrapper}>{children}</div>
        <SideBar
          opened={this.state.sideMenuTriggered}
          closeSideBar={this.handleSideBarClose}
          selectedCanadaEN={selectedCanadaEN}
          selectedCanadaFR={selectedCanadaFR}
          selectedUSA={selectedUSA}
          country={country}
          language={language}
        />
      </div>
    );
  }
}

Layout.propTypes = {
  title: PropTypes.string,
  clicked: PropTypes.func,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func.isRequired,
  selectedCanadaFR: PropTypes.func.isRequired,
  selectedUSA: PropTypes.func.isRequired,
  wideHeading: PropTypes.string
};

export default Layout;
